import { render, staticRenderFns } from "./ModalWindowSpeedTest.vue?vue&type=template&id=92005ac6&scoped=true&"
import script from "./ModalWindowSpeedTest.vue?vue&type=script&lang=js&"
export * from "./ModalWindowSpeedTest.vue?vue&type=script&lang=js&"
import style0 from "./ModalWindowSpeedTest.vue?vue&type=style&index=0&id=92005ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92005ac6",
  null
  
)

export default component.exports